var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MainAsideRightHead',{attrs:{"title":_vm.headTitle,"store-path":"usersGroups","can-save":_vm.canSave,"options-visible":false,"save-text":_vm.saveText,"is-loading":_vm.loading},on:{"save":_vm.save}})}
var staticRenderFns = []

export { render, staticRenderFns }